import { ChannelStatusEnum } from '@/utilities/paperwork/enums/ChannelStatusEnum'

export default {
  isNew: state => (equipmentRef, channelId) => {
    const containerIndex = state?.container?.findIndex(
      element => element.equipmentRef === equipmentRef && 'equipments' in element && 'channels' in element.equipments,
    )

    if (containerIndex === -1) {
      return false
    }

    return state.container[containerIndex].equipments.channels.some(({ id, status }) => {
      return id === channelId && status === ChannelStatusEnum.NEW
    })
  },
}
